import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import getters from "./getters";

Vue.use(Vuex);

const files = require.context("./modules", false, /\.js$/);
const modules = {};
files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, "")] = files(key).default;
});
// modules.user = modules.user || {};
// delete modules.user;
export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== "production",
  // plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
  modules,
  state: {
    direction: "in",
    transitionPop: false,
    isIpForbid: "", // ip限制
    showGuideNow: false, //新手指导要不要打开
    routerCount: 0, // 路由经过
    systemMaintenanceInfo: {}, // 系统维护信息
    h5CanReceiveRedPacket: false,
    //跳转选择线路页面
    // jumpSwitch: configText.switchingLines, //jumpPage跳转(重要:马会部署->true; 其他盘口->false)
    //是否已经从jumpPage跳转出来过
    alReadyJumped: false
  },
  getters: {
    ...getters,
    createLogger,
    systemMaintenanceInfo: state => state.systemMaintenanceInfo,
    h5CanReceiveRedPacket: state => state.h5CanReceiveRedPacket,
    alReadyJumped: state => state.alReadyJumped,
    jumpSwitch: state => state.jumpSwitch
  },
  mutations: {
    setH5CanReceiveRedPacket(state, bool) {
      state.h5CanReceiveRedPacket = bool;
    },
    showGuideNow(state, bool) {
      state.showGuideNow = bool;
    },
    getDirection(state, data) {
      state.direction = data;
    },
    getTransitionPop(state, data) {
      state.transitionPop = data;
    },
    getIpForbid(state, data) {
      state.isIpForbid = data;
    },
    SET_ROUTER_COUNT(state, data) {
      state.routerCount = data;
    },
    SET_SYSTEM_MAINTENANCE_INFO(state, data) {
      localStorage.setItem("CODE_503", JSON.stringify(data || null));
      state.systemMaintenanceInfo = data;
    },
    SET_JUMP_SWITCH(state, data) {
      state.jumpSwitch = data;
    },
    SET_ALREADY_JUMPED(state, data) {
      state.alReadyJumped = data;
    }
  }
});
